import React from 'react';
import { Box, Typography, Stack, Paper, IconButton } from '@mui/material';
import { AttachFile, Delete as DeleteIcon } from '@mui/icons-material';
import { UPLOAD_DIALOG_STYLES, UPLOAD_DIALOG_COLORS, formatFileSize } from '../../../../../common/styles/dialogStyles';
import { FileWithPreview } from '../hooks';

interface FileListProps {
  files: FileWithPreview[];
  onRemove: (fileId: string) => void;
  isUploading: boolean;
}

export const FileList: React.FC<FileListProps> = ({ files, onRemove, isUploading }) => {
  if (files.length === 0) return null;

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{ mb: 2, fontWeight: 600, color: UPLOAD_DIALOG_COLORS.textPrimary }}
      >
        Selected Files ({files.length})
      </Typography>

      <Stack spacing={1}>
        {files.map((fileWithPreview) => (
          <Paper key={fileWithPreview.id} sx={UPLOAD_DIALOG_STYLES.fileItem}>
            <AttachFile sx={{ color: UPLOAD_DIALOG_COLORS.textMuted }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {fileWithPreview.file.name}
              </Typography>
              <Typography variant="caption" sx={{ color: UPLOAD_DIALOG_COLORS.textMuted }}>
                {formatFileSize(fileWithPreview.file.size)}
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => onRemove(fileWithPreview.id)}
              disabled={isUploading}
              sx={{ color: UPLOAD_DIALOG_COLORS.error }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};

export default FileList;
